import React from 'react';
import RecentProofCard from '../../../pages/user-profile-dashboard/components/RecentProofCard';
import SkeletonLoader from '../../../pages/user-profile-dashboard/components/SkeletonLoader';
import SectionHeader from '../SectionHeader';

const RecentProofsSection = ({
  recentProofs,
  onOpenDetail,
  isLoading,
  hasMore,
  observerTarget,
}) => {
  return (
    <div>
      <SectionHeader title="최근 증명" />

      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-6">
        {(recentProofs || []).map((proof) => (
          <RecentProofCard key={proof?.id} proof={proof} onOpenDetail={onOpenDetail} />
        ))}
      </div>

      {isLoading && <SkeletonLoader />}
      {hasMore && <div ref={observerTarget} className="h-10" />}
      {!hasMore && (recentProofs || []).length > 0 ? (
        <div className="text-center py-8">
          <p className="text-sm md:text-base text-muted-foreground">모든 증명을 불러왔습니다</p>
        </div>
      ) : null}
    </div>
  );
};

export default RecentProofsSection;
